export default "__VITE_ASSET__g$TB0m7g__"